import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CardBody } from "reactstrap";
import { getAllWishList } from "../../../redux/booking/action";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import * as XLSX from "xlsx";
import axiosInstance from "../../../redux/api";
import search from "../../assets/images/search-lg.svg"
import NormalCardHeader from "../../Common/CardHeader/NormalCardHeader";



const WishlistList = () => {
  const [params, setParams] = useState({
    page: 1,
    type: 1,
    search_key: "",
  });
  const list = useSelector((state) => state.reusableSlice.wishlistList);
  const pagination_meta = list?.pagination;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllWishList(params));
  }, [dispatch, params]);

  //   const viewComponent = (cart_id) => {
  //     navigate(`/viewpage/${cart_id}`);
  //   };
  const handlePageChange = (newPage) => {
    setParams((prevParams) => ({
      ...prevParams,
      page: newPage,
    }));
  };

  // csv file convert
  const handleExportCSV = async (e) => {
    e.preventDefault();
  
    // Remove `page` to avoid backend type errors
    const { page, ...restParams } = params;
    const filterParams = {
      ...restParams,
      page: "",
    };
  
    try {
      const response = await axiosInstance.post(`wishlist/get_wishlist`, filterParams);
      const wishlist = response?.data?.response?.wishlist || [];
  
      if (!wishlist.length) return;
  
      const header = [["Customer Info", "Product Name", "Created On"]];
    
      const data = wishlist.map((item) => [
        item.email_id || item.mobile_number || "No Customer Info",
        item.product_name || "",
        item.created_on?.split(" ")[0] || "",
      ]);
    
      const worksheet = XLSX.utils.aoa_to_sheet(header);
      XLSX.utils.sheet_add_aoa(worksheet, data, { origin: "A2" });
    
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Wishlist");
    
      XLSX.writeFile(workbook, "Wishlist.csv", { bookType: "csv" });
    } catch (error) {
      console.error("Wishlist Export Error:", error);
    }
  };
  

  { console.log(list, "item.wishlist.id") }
  return (
    <div className="card-head order-card">
      <div className="sub-head">
        <h4>Wishlist</h4>
      </div>
      <NormalCardHeader
        params={params}
        setParams={setParams}
        search={search}
      />
      <div className="table-category mt-3">
        <div className="table-first-top d-flex justify-content-between align-items-center">
          
          <div className="d-flex justify-content-end align-items-center table-right">
            {/* Filter by
            <select

            >
              <option value="">All</option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
            </select> */}
            <button className="btn btn-primary" onClick={handleExportCSV}>
    Export CSV
  </button>
          </div>
        </div>
        <div className="table-sec table-responsive">

          <table className="table">
            <thead>
              <tr>
                <th scope="col">Customer Info</th>
                <th scope="col">Product Name</th>
                <th scope="col">Created on</th>
              </tr>
            </thead>
            <tbody>
              {list.wishlist?.map((item) => (
                <tr>
                  <td>{ item.email_id  || item.mobile_number || "No Customer Info"}</td>
                  <td>
                    <div className="d-flex td-img align-items-center">
                      <img src={item.product_image} />
                      <h6>{item.product_name}</h6>
                    </div>
                  </td>
                  <td>{item.created_on.split(" ")[0]}</td>
                </tr>

              ))}
            </tbody>
          </table>
        </div>
        {/* Pagination Component */}
        <div className="pagination-section">
          {pagination_meta && (
            <CommonPagination
              currentPage={pagination_meta.current_page}
              totalPages={pagination_meta.pages}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default WishlistList;
